import { ItemList } from 'v2/models';
import { IPath, findNodeWithPath, gatherFiles } from './getFileTree';
import { computeFolderSelectionStateRec } from './getFolderState';

export function folderClickHandler(
  treeRoot: IPath | undefined,
  path: string,
  currentSelection: ItemList
): ItemList {
  if (!treeRoot) {
    return currentSelection;
  }
  const node = findNodeWithPath(treeRoot, path);
  if (!node) {
    return currentSelection;
  }

  const files = gatherFiles(node);
  const fileIds = new Set(files.map(({ id }) => id));

  const state = computeFolderSelectionStateRec(node, currentSelection);
  // remove all files in this dir from the selection
  if (state === 'Every') {
    return {
      ...currentSelection,
      list: currentSelection.list.filter(({ id }) => !fileIds.has(id)),
    };
  }

  // add all the files from this dir to the selection
  if (state === 'None' || state === 'Some') {
    const currentlySelectedIds = new Set(
      currentSelection.list.map(({ id }) => id)
    );

    return {
      ...currentSelection,
      list: [
        ...currentSelection.list,
        ...files.filter(({ id }) => !currentlySelectedIds.has(id)),
      ],
    };
  }

  return currentSelection;
}
